var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11284_15674",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208008,
    y: 0.736328,
    width: 22.9194,
    height: 22.9194,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11284_15674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7126 17.688C10.5057 17.688 10.3347 17.6205 10.1997 17.4855C10.0641 17.3499 9.99633 17.1786 9.99633 16.9717C9.99633 16.7648 10.0641 16.5936 10.1997 16.458C10.3347 16.323 10.5057 16.2555 10.7126 16.2555H12.6225C12.8294 16.2555 13.0007 16.323 13.1363 16.458C13.2713 16.5936 13.3387 16.7648 13.3387 16.9717C13.3387 17.1786 13.2713 17.3499 13.1363 17.4855C13.0007 17.6205 12.8294 17.688 12.6225 17.688H10.7126ZM4.02775 7.78012C3.82084 7.78012 3.6499 7.70849 3.51493 7.56525C3.37933 7.422 3.31152 7.25488 3.31152 7.06389C3.31152 6.85698 3.37933 6.68603 3.51493 6.55107C3.6499 6.41546 3.82084 6.34766 4.02775 6.34766H19.3073C19.5142 6.34766 19.6855 6.41546 19.8211 6.55107C19.9561 6.68603 20.0236 6.85698 20.0236 7.06389C20.0236 7.25488 19.9561 7.422 19.8211 7.56525C19.6855 7.70849 19.5142 7.78012 19.3073 7.78012H4.02775ZM6.89267 12.7221C6.68576 12.7221 6.51482 12.6543 6.37985 12.5187C6.24425 12.3837 6.17644 12.2128 6.17644 12.0059C6.17644 11.8149 6.24425 11.6478 6.37985 11.5045C6.51482 11.3613 6.68576 11.2896 6.89267 11.2896H16.4424C16.6493 11.2896 16.8206 11.3613 16.9562 11.5045C17.0911 11.6478 17.1586 11.8149 17.1586 12.0059C17.1586 12.2128 17.0911 12.3837 16.9562 12.5187C16.8206 12.6543 16.6493 12.7221 16.4424 12.7221H6.89267Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c5c8f62639840c83a80d2a36053ac405.svg";
export { ForwardRef as ReactComponent };